import styled from 'styled-components';
import { SPACINGS } from '@qadra/frontend-common-ts';

export const mobileSpacing = SPACINGS[4];

export const MobileContainer = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: center;
  flex-direction: column;
  margin: 0 ${mobileSpacing} 60px;
`;

export const MobileButtonContainer = styled.div`
  position: fixed;
  display: flex;
  justify-content: space-between;
  bottom: ${mobileSpacing};
  left: 0px;
  right: 0px;
  margin: 0 ${SPACINGS[2]};
  z-index: 3;

  & > button,
  & > span {
    flex: 1 1 auto;
    margin: 0 ${SPACINGS[2]};
  }
`;
